import React from "react";

export const CalenderIcon = (props) => (
  <span {...props}>
    <svg
      width="229"
      height="228"
      viewBox="0 0 229 228"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M171.375 23.125H216.875C219.892 23.125 222.785 24.3234 224.918 26.4567C227.052 28.5899 228.25 31.4832 228.25 34.5V216.5C228.25 219.517 227.052 222.41 224.918 224.543C222.785 226.677 219.892 227.875 216.875 227.875H12.125C9.10816 227.875 6.21489 226.677 4.08166 224.543C1.94843 222.41 0.75 219.517 0.75 216.5V34.5C0.75 31.4832 1.94843 28.5899 4.08166 26.4567C6.21489 24.3234 9.10816 23.125 12.125 23.125H57.625V0.375H80.375V23.125H148.625V0.375H171.375V23.125ZM205.5 114.125H23.5V205.125H205.5V114.125ZM148.625 45.875H80.375V68.625H57.625V45.875H23.5V91.375H205.5V45.875H171.375V68.625H148.625V45.875ZM46.25 136.875H69V159.625H46.25V136.875ZM103.125 136.875H125.875V159.625H103.125V136.875ZM160 136.875H182.75V159.625H160V136.875Z"
        fill="white"
      />
    </svg>
  </span>
);

export const MenuCloseIcon = (props) => (
  <span {...props}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      class="h-6 w-6"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      stroke-width="2"
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M6 18L18 6M6 6l12 12"
      />
    </svg>
  </span>
);

export const UpdateIcon = (props) => (
  <span {...props}>
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.00645 3.06363C5.66979 1.62232 7.79777 0.830312 9.9987 0.833383C15.0614 0.833383 19.1654 4.9373 19.1654 10C19.1654 11.958 18.5512 13.773 17.5062 15.2617L14.582 10H17.332C17.3321 8.56237 16.9097 7.15637 16.1171 5.95687C15.3246 4.75737 14.197 3.81728 12.8744 3.2535C11.5519 2.68971 10.0929 2.52711 8.67866 2.7859C7.26446 3.04469 5.95753 3.71346 4.92036 4.70905L4.00645 3.06363ZM15.9909 16.9365C14.3276 18.3778 12.1996 19.1698 9.9987 19.1667C4.93595 19.1667 0.832031 15.0628 0.832031 10C0.832031 8.04205 1.4462 6.22705 2.4912 4.73838L5.41536 10H2.66536C2.66525 11.4377 3.08772 12.8437 3.88026 14.0432C4.67279 15.2427 5.80043 16.1828 7.12295 16.7466C8.44547 17.3104 9.90454 17.473 11.3187 17.2142C12.7329 16.9554 14.0399 16.2866 15.077 15.291L15.9909 16.9365Z"
        fill="white"
      />
    </svg>
  </span>
);
export const DeleteIcon = (props) => (
  <span {...props}>
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.582 4.50004H19.1654V6.33337H17.332V18.25C17.332 18.4932 17.2355 18.7263 17.0635 18.8982C16.8916 19.0701 16.6585 19.1667 16.4154 19.1667H3.58203C3.33892 19.1667 3.10576 19.0701 2.93385 18.8982C2.76194 18.7263 2.66536 18.4932 2.66536 18.25V6.33337H0.832031V4.50004H5.41536V1.75004C5.41536 1.50693 5.51194 1.27377 5.68385 1.10186C5.85576 0.929951 6.08892 0.833374 6.33203 0.833374H13.6654C13.9085 0.833374 14.1416 0.929951 14.3135 1.10186C14.4855 1.27377 14.582 1.50693 14.582 1.75004V4.50004ZM15.4987 6.33337H4.4987V17.3334H15.4987V6.33337ZM7.2487 9.08337H9.08203V14.5834H7.2487V9.08337ZM10.9154 9.08337H12.7487V14.5834H10.9154V9.08337ZM7.2487 2.66671V4.50004H12.7487V2.66671H7.2487Z"
        fill="white"
      />
    </svg>
  </span>
);
export const ChangePassIcon = (props) => (
  <span {...props}>
    <svg
      width="18"
      height="20"
      viewBox="0 0 18 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.4167 8.16671H16.3333C16.5764 8.16671 16.8096 8.26328 16.9815 8.43519C17.1534 8.6071 17.25 8.84026 17.25 9.08337V18.25C17.25 18.4932 17.1534 18.7263 16.9815 18.8982C16.8096 19.0701 16.5764 19.1667 16.3333 19.1667H1.66667C1.42355 19.1667 1.19039 19.0701 1.01849 18.8982C0.846577 18.7263 0.75 18.4932 0.75 18.25V9.08337C0.75 8.84026 0.846577 8.6071 1.01849 8.43519C1.19039 8.26328 1.42355 8.16671 1.66667 8.16671H2.58333V7.25004C2.58333 6.40739 2.74931 5.57299 3.07177 4.79449C3.39424 4.01598 3.86689 3.30861 4.46273 2.71277C5.05857 2.11693 5.76594 1.64428 6.54445 1.32181C7.32295 0.999346 8.15735 0.833374 9 0.833374C9.84265 0.833374 10.677 0.999346 11.4556 1.32181C12.2341 1.64428 12.9414 2.11693 13.5373 2.71277C14.1331 3.30861 14.6058 4.01598 14.9282 4.79449C15.2507 5.57299 15.4167 6.40739 15.4167 7.25004V8.16671ZM2.58333 10V17.3334H15.4167V10H2.58333ZM8.08333 11.8334H9.91667V15.5H8.08333V11.8334ZM13.5833 8.16671V7.25004C13.5833 6.03447 13.1004 4.86868 12.2409 4.00913C11.3814 3.14959 10.2156 2.66671 9 2.66671C7.78442 2.66671 6.61864 3.14959 5.75909 4.00913C4.89955 4.86868 4.41667 6.03447 4.41667 7.25004V8.16671H13.5833Z"
        fill="white"
      />
    </svg>
  </span>
);
export const DeactivateIcon = (props) => (
  <span {...props}>
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.74162 2.48979L5.79303 3.99221C4.51537 4.88666 3.55614 6.16517 3.05471 7.64201C2.55328 9.11884 2.53575 10.7171 3.00467 12.2046C3.4736 13.692 4.40455 14.9913 5.66229 15.9135C6.92004 16.8358 8.43906 17.333 9.9987 17.333C11.5583 17.333 13.0774 16.8358 14.3351 15.9135C15.5929 14.9913 16.5238 13.692 16.9927 12.2046C17.4617 10.7171 17.4441 9.11884 16.9427 7.64201C16.4413 6.16517 15.482 4.88666 14.2044 3.99221L15.2558 2.48979C16.4639 3.33443 17.4502 4.45829 18.1309 5.76584C18.8115 7.07338 19.1664 8.52594 19.1654 10C19.1654 15.0628 15.0615 19.1667 9.9987 19.1667C4.93595 19.1667 0.832034 15.0628 0.832034 10C0.830972 8.52594 1.18586 7.07338 1.86652 5.76584C2.54718 4.45829 3.5335 3.33443 4.74162 2.48979ZM9.08204 10V0.833374H10.9154V10H9.08204Z"
        fill="white"
      />
    </svg>
  </span>
);
export const ActivateIcon = (props) => (
  <span {...props}>
    <svg
      width="18"
      height="20"
      viewBox="0 0 18 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.6654 13.6667C15.1843 13.6667 16.4154 14.8978 16.4154 16.4167C16.4154 17.9356 15.1843 19.1667 13.6654 19.1667C12.1464 19.1667 10.9154 17.9356 10.9154 16.4167C10.9154 14.8978 12.1464 13.6667 13.6654 13.6667ZM4.4987 10C6.52453 10 8.16536 11.6409 8.16536 13.6667C8.16536 15.6925 6.52453 17.3334 4.4987 17.3334C2.47286 17.3334 0.832031 15.6925 0.832031 13.6667C0.832031 11.6409 2.47286 10 4.4987 10ZM13.6654 15.5C13.1594 15.5 12.7487 15.9107 12.7487 16.4167C12.7487 16.9227 13.1594 17.3334 13.6654 17.3334C14.1714 17.3334 14.582 16.9227 14.582 16.4167C14.582 15.9107 14.1714 15.5 13.6654 15.5ZM4.4987 11.8334C3.48578 11.8334 2.66536 12.6538 2.66536 13.6667C2.66536 14.6796 3.48578 15.5 4.4987 15.5C5.51161 15.5 6.33203 14.6796 6.33203 13.6667C6.33203 12.6538 5.51161 11.8334 4.4987 11.8334ZM12.2904 0.833374C15.0752 0.833374 17.332 3.09021 17.332 5.87504C17.332 8.65987 15.0752 10.9167 12.2904 10.9167C9.50553 10.9167 7.2487 8.65987 7.2487 5.87504C7.2487 3.09021 9.50553 0.833374 12.2904 0.833374ZM12.2904 2.66671C10.5184 2.66671 9.08203 4.10312 9.08203 5.87504C9.08203 7.64696 10.5184 9.08337 12.2904 9.08337C14.0623 9.08337 15.4987 7.64696 15.4987 5.87504C15.4987 4.10312 14.0623 2.66671 12.2904 2.66671Z"
        fill="white"
      />
    </svg>
  </span>
);
export const CloseIcon = ({ size }) => (
  <>
    <svg
      viewBox="0 0 24 24"
      width={size}
      height={size}
      stroke="currentColor"
      strokeWidth="2"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="css-i6dzq1"
    >
      <line x1="18" y1="6" x2="6" y2="18"></line>
      <line x1="6" y1="6" x2="18" y2="18"></line>
    </svg>
  </>
);
export const MessageIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="h-7 w-7"
      fill="none"
      viewBox="0 0 24 24"
      stroke="#D6D6D6"
      strokeWidth={2}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z"
      />
    </svg>
  );
};
export const AdminIcon = () => {
  return (
    //   <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
    //   <path stroke-linecap="round" stroke-linejoin="round" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
    // </svg>
    <svg
      width="26"
      height="24"
      viewBox="0 0 19 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 13V15C6.4087 15 4.88258 15.6321 3.75736 16.7574C2.63214 17.8826 2 19.4087 2 21H0C0 18.8783 0.842855 16.8434 2.34315 15.3431C3.84344 13.8429 5.87827 13 8 13V13ZM8 12C4.685 12 2 9.315 2 6C2 2.685 4.685 0 8 0C11.315 0 14 2.685 14 6C14 9.315 11.315 12 8 12ZM8 10C10.21 10 12 8.21 12 6C12 3.79 10.21 2 8 2C5.79 2 4 3.79 4 6C4 8.21 5.79 10 8 10ZM10.595 17.812C10.4682 17.2784 10.4682 16.7226 10.595 16.189L9.603 15.616L10.603 13.884L11.595 14.457C11.9932 14.0799 12.4745 13.8017 13 13.645V12.5H15V13.645C15.532 13.803 16.012 14.085 16.405 14.457L17.397 13.884L18.397 15.616L17.405 16.189C17.5316 16.7223 17.5316 17.2777 17.405 17.811L18.397 18.384L17.397 20.116L16.405 19.543C16.0068 19.9201 15.5255 20.1983 15 20.355V21.5H13V20.355C12.4745 20.1983 11.9932 19.9201 11.595 19.543L10.603 20.116L9.603 18.384L10.595 17.812V17.812ZM14 18.5C14.3978 18.5 14.7794 18.342 15.0607 18.0607C15.342 17.7794 15.5 17.3978 15.5 17C15.5 16.6022 15.342 16.2206 15.0607 15.9393C14.7794 15.658 14.3978 15.5 14 15.5C13.6022 15.5 13.2206 15.658 12.9393 15.9393C12.658 16.2206 12.5 16.6022 12.5 17C12.5 17.3978 12.658 17.7794 12.9393 18.0607C13.2206 18.342 13.6022 18.5 14 18.5Z"
        fill="#D6D6D6"
      />
    </svg>
  );
};
export const BriefcaseIcon = () => (
  <>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="h-6 w-6"
      fill="none"
      viewBox="0 0 24 24"
      stroke="#D6D6D6"
      strokeWidth={2}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
      />
    </svg>
  </>
);
export const HomeIcon = () => (
  <>
    <svg
      width="26"
      height="24"
      viewBox="0 0 22 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18 20H4C3.73478 20 3.48043 19.8946 3.29289 19.7071C3.10536 19.5196 3 19.2652 3 19V9.99998H0L10.327 0.611981C10.5111 0.444459 10.7511 0.351624 11 0.351624C11.2489 0.351624 11.4889 0.444459 11.673 0.611981L22 9.99998H19V19C19 19.2652 18.8946 19.5196 18.7071 19.7071C18.5196 19.8946 18.2652 20 18 20ZM5 18H17V8.15698L11 2.70298L5 8.15698V18Z"
        fill="#D6D6D6"
      />
    </svg>

    {/* <svg
      viewBox="0 0 24 24"
      width="26"
      height="24"
      stroke="currentColor"
      strokeWidth="2"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="css-i6dzq1"
    >
      <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
      <polyline points="9 22 9 12 15 12 15 22"></polyline>
    </svg> */}
  </>
);

export const SignOutIcon = () => {
  return (
    <svg
      viewBox="0 0 24 24"
      width={26}
      height={24}
      stroke="#D6D6D6"
      strokeWidth={2}
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="css-i6dzq1"
    >
      <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
      <polyline points="16 17 21 12 16 7" />
      <line x1={21} y1={12} x2={9} y2={12} />
    </svg>
  );
};

export const MenuIcon = () => {
  return (
    <svg
      viewBox="0 0 24 24"
      width={26}
      height={24}
      stroke="currentColor"
      strokeWidth={2}
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="css-i6dzq1"
    >
      <line x1={3} y1={12} x2={21} y2={12} />
      <line x1={3} y1={6} x2={21} y2={6} />
      <line x1={3} y1={18} x2={21} y2={18} />
    </svg>
  );
};

export const UserIcon = () => {
  return (
    // <svg
    //   viewBox="0 0 24 24"
    //   width={26}
    //   height={24}
    //   stroke="currentColor"
    //   strokeWidth={2}
    //   fill="none"
    //   strokeLinecap="round"
    //   strokeLinejoin="round"
    //   className="css-i6dzq1"
    // >
    //   <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
    //   <circle cx={12} cy={7} r={4} />
    // </svg>
    <svg
      width="26"
      height="24"
      viewBox="0 0 20 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 0.993C0.00183004 0.730378 0.1069 0.479017 0.292513 0.293218C0.478126 0.107418 0.72938 0.00209465 0.992 0H19.008C19.556 0 20 0.445 20 0.993V17.007C19.9982 17.2696 19.8931 17.521 19.7075 17.7068C19.5219 17.8926 19.2706 17.9979 19.008 18H0.992C0.728813 17.9997 0.476497 17.895 0.290489 17.7088C0.104482 17.5226 -1.33455e-07 17.2702 0 17.007V0.993ZM2 2V16H18V2H2ZM4 4H10V10H4V4ZM6 6V8H8V6H6ZM4 12H16V14H4V12ZM12 4H16V6H12V4ZM12 8H16V10H12V8Z"
        fill="#D6D6D6"
      />
    </svg>
  );
};

export const SettingIcon = () => {
  return (
    <svg
      viewBox="0 0 24 24"
      width={24}
      height={26}
      stroke="currentColor"
      strokeWidth={2}
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="css-i6dzq1"
    >
      <circle cx={12} cy={12} r={3} />
      <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z" />
    </svg>
  );
};

export const LoadingIcon = () => {
  return (
    <svg
      className="animate-spin h-5 w-5 text-white"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
    >
      <circle
        className="opacity-25"
        cx={12}
        cy={12}
        r={10}
        stroke="currentColor"
        strokeWidth={4}
      />
      <path
        className="opacity-75"
        fill="currentColor"
        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
      />
    </svg>
  );
};

export const SearchIcon = () => {
  return (
    <svg width={24} height={24} fill="none" aria-hidden="true">
      <path
        d="m19 19-3.5-3.5"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle
        cx={11}
        cy={11}
        r={6}
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const DownIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width={20}
      height={35}
      viewBox="0 0 20 35"
      fill="none"
    >
      <rect width={20} height={35} fill="url(#pattern0)" />
      <defs>
        <pattern
          id="pattern0"
          patternContentUnits="objectBoundingBox"
          width={1}
          height={1}
        >
          <use
            xlinkHref="#image0_478_852"
            transform="translate(-0.375) scale(0.00341797 0.00195312)"
          />
        </pattern>
        <image
          id="image0_478_852"
          width={512}
          height={512}
          xlinkHref="data:image/png;base64,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"
        />
      </defs>
    </svg>
  );
};

export const UpIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width={20}
      height={35}
      viewBox="0 0 20 35"
      fill="none"
    >
      <rect
        width={20}
        height={35}
        transform="matrix(1 0 0 -1 0 35)"
        fill="url(#pattern1)"
      />
      <defs>
        <pattern
          id="pattern1"
          patternContentUnits="objectBoundingBox"
          width={1}
          height={1}
        >
          <use
            xlinkHref="#image0_478_2115"
            transform="translate(-0.375) scale(0.00341797 0.00195312)"
          />
        </pattern>
        <image
          id="image0_478_2115"
          width={512}
          height={512}
          xlinkHref="data:image/png;base64,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"
        />
      </defs>
    </svg>
  );
};

export const ListIcon = () => {
  return (
    <svg
      viewBox="0 0 24 24"
      width={24}
      height={24}
      stroke="currentColor"
      strokeWidth={2}
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="css-i6dzq1"
    >
      <line x1={8} y1={6} x2={21} y2={6} />
      <line x1={8} y1={12} x2={21} y2={12} />
      <line x1={8} y1={18} x2={21} y2={18} />
      <line x1={3} y1={6} x2="3.01" y2={6} />
      <line x1={3} y1={12} x2="3.01" y2={12} />
      <line x1={3} y1={18} x2="3.01" y2={18} />
    </svg>
  );
};

export const DataIcon = ({ size }) => {
  return (
    <svg
      viewBox="0 0 24 24"
      width={size}
      height={size}
      stroke="currentColor"
      strokeWidth={2}
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="css-i6dzq1"
    >
      <polyline points="22 12 16 12 14 15 10 15 8 12 2 12" />
      <path d="M5.45 5.11L2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z" />
    </svg>
  );
};

export const CheckIcon = ({ size = 24 }) => {
  return (
    <svg
      viewBox="0 0 24 24"
      width={24}
      height={24}
      stroke="currentColor"
      strokeWidth={2}
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="css-i6dzq1"
    >
      <polyline points="20 6 9 17 4 12" />
    </svg>
  );
};

export const XSquareIcon = ({ size = 24 }) => {
  return (
    <svg
      viewBox="0 0 24 24"
      width={size}
      height={size}
      stroke="currentColor"
      strokeWidth={2}
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="css-i6dzq1"
    >
      <rect x={3} y={3} width={18} height={18} rx={2} ry={2} />
      <line x1={9} y1={9} x2={15} y2={15} />
      <line x1={15} y1={9} x2={9} y2={15} />
    </svg>
  );
};

export const PlusIcon = () => {
  return (
    <svg
      className="group-hover:text-blue-500 mb-1 text-slate-400"
      width={20}
      height={20}
      fill="currentColor"
      aria-hidden="true"
    >
      <path d="M10 5a1 1 0 0 1 1 1v3h3a1 1 0 1 1 0 2h-3v3a1 1 0 1 1-2 0v-3H6a1 1 0 1 1 0-2h3V6a1 1 0 0 1 1-1Z" />
    </svg>
  );
};

export const WhiteDownIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width={30}
      height={43}
      viewBox="0 0 30 43"
      fill="currentColor"
    >
      <rect width={30} height={43} fill="url(#pattern2)" />
      <defs>
        <pattern
          id="pattern2"
          patternContentUnits="objectBoundingBox"
          width={1}
          height={1}
        >
          <use
            xlinkHref="#image0_490_202"
            transform="translate(-0.216667) scale(0.00279948 0.00195312)"
          />
        </pattern>
        <image
          id="image0_490_202"
          width={512}
          height={512}
          xlinkHref="data:image/png;base64,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"
        />
      </defs>
    </svg>
  );
};

export const GreenDownIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width={30}
      height={43}
      viewBox="0 0 30 43"
      fill="none"
    >
      <rect width={30} height={43} fill="url(#pattern3)" />
      <defs>
        <pattern
          id="pattern3"
          patternContentUnits="objectBoundingBox"
          width={1}
          height={1}
        >
          <use
            xlinkHref="#image0_490_917"
            transform="translate(-0.216667) scale(0.00279948 0.00195312)"
          />
        </pattern>
        <image
          id="image0_490_917"
          width={512}
          height={512}
          xlinkHref="data:image/png;base64,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"
        />
      </defs>
    </svg>
  );
};

export const SmallWhiteDownIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width={14}
      height={12}
      viewBox="0 0 14 12"
      fill="none"
    >
      <rect width={14} height={12} fill="url(#pattern4)" />
      <defs>
        <pattern
          id="pattern4"
          patternContentUnits="objectBoundingBox"
          width={1}
          height={1}
        >
          <use
            xlinkHref="#image0_501_66"
            transform="translate(0 -0.0833333) scale(0.00195312 0.00227865)"
          />
        </pattern>
        <image
          id="image0_501_66"
          width={512}
          height={512}
          xlinkHref="data:image/png;base64,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"
        />
      </defs>
    </svg>
  );
};

export const InfoIcon = () => {
  return (
    <svg
      width={28}
      height={28}
      strokeWidth="1.5"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 11.5V16.5"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 7.51L12.01 7.49889"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const DocumentIcon = () => {
  return (
    <svg
      width={24}
      height={24}
      strokeWidth="1.5"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4 21.4V2.6C4 2.26863 4.26863 2 4.6 2H16.2515C16.4106 2 16.5632 2.06321 16.6757 2.17574L19.8243 5.32426C19.9368 5.43679 20 5.5894 20 5.74853V21.4C20 21.7314 19.7314 22 19.4 22H4.6C4.26863 22 4 21.7314 4 21.4Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16 5.4V2.35355C16 2.15829 16.1583 2 16.3536 2C16.4473 2 16.5372 2.03725 16.6036 2.10355L19.8964 5.39645C19.9628 5.46275 20 5.55268 20 5.64645C20 5.84171 19.8417 6 19.6464 6H16.6C16.2686 6 16 5.73137 16 5.4Z"
        fill="currentColor"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 10L16 10"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 18L16 18"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 14L12 14"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ChevronUpIcon = () => {
  return (
    <svg
      viewBox="0 0 24 24"
      width={28}
      height={28}
      stroke="currentColor"
      strokeWidth={2}
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="css-i6dzq1"
    >
      <polyline points="18 15 12 9 6 15" />
    </svg>
  );
};

export const BackIcon = ({ size = 24 }) => {
  return (
    <svg
      viewBox="0 0 24 24"
      width={size}
      height={size}
      stroke="currentColor"
      strokeWidth={2}
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="css-i6dzq1"
    >
      <polyline points="15 18 9 12 15 6" />
    </svg>
  );
};

export const IconMoreHorizontal = ({ size = 24 }) => {
  return (
    <svg
      viewBox="0 0 24 24"
      width={24}
      height={24}
      stroke="currentColor"
      strokeWidth={2}
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="css-i6dzq1"
    >
      <circle cx={12} cy={12} r={1} />
      <circle cx={19} cy={12} r={1} />
      <circle cx={5} cy={12} r={1} />
    </svg>
  );
};

export const IconPower = ({ size = 24 }) => {
  return (
    <svg
      viewBox="0 0 24 24"
      width={size}
      height={size}
      stroke="currentColor"
      strokeWidth={2}
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="css-i6dzq1"
    >
      <path d="M18.36 6.64a9 9 0 1 1-12.73 0" />
      <line x1={12} y1={2} x2={12} y2={12} />
    </svg>
  );
};
